export default __webpack_public_path__ + "static/media/icon-facebook-messager.c7a0985c.svg";